import { getInjection } from '@/di/inversify.config';
import { Result } from '@/entities';
import { SystemLocationsCourts } from '@/entities/SystemLocationsCourts';

export const getSystemLocationCourtsUseCase = async (
	moduleFor: string,
	moduleUuid: string,
	locationId: string
): Promise<Result<SystemLocationsCourts[]>> => {
	const systemLocationsRepository = getInjection('ISystemLocationsRepository');
	return systemLocationsRepository.getSystemLocationCourts(moduleFor, moduleUuid, locationId);
};
